export default __webpack_public_path__ + "static/datelabel-dropdown-do-2-dark-0f942379b43282c762e41739131b1af6.png";